import axios, { AxiosInstance } from "axios";

export default class PdfGenerationRequest {
  protected readonly baseURL: URL;
  protected readonly axiosInstance: AxiosInstance;

  constructor() {
    this.baseURL = new URL("", process.env.VUE_APP_PDF_GENERATION_API_BASE_URL);

    this.axiosInstance = axios.create({
      baseURL: `${this.baseURL}`,
      headers: {
        "x-api-key": process.env.VUE_APP_HTML_TO_PDF_BASE_URL_API_TOKEN,
      },
    });
  }

  createGenerationRequest(data: any = {}) {
    return this.axiosInstance({
      url: "/",
      method: "post",
      data: data,
    });
  }

  readGenerationRequest(requestId: string) {
    return this.axiosInstance({
      url: `/${requestId}`,
      method: "get",
    });
  }
}